<template>
  <span>{{ countDown }}</span>
</template>
<script setup>
const props = {};
const emit = defineEmits(["timeout"]);
const countDown = ref(40);
const interval = ref(null);
const route = useRoute();
onMounted(() => {
  console.log("開始錄音倒數");
  if (route.name === "BookReading") {
    countDown.value = 120;
  } else {
    countDown.value = 40;
  }
  interval.value = null;
  interval.value = setInterval(function () {
    countDown.value = countDown.value - 1;
    if (countDown.value === 0) {
      clearInterval(interval.value);
      emit("timeout");
    }
  }, 1000);
});
onBeforeUnmount(() => {
  console.log("停止錄音倒數");
  clearInterval(interval.value);
});
//   interval.value = setInterval(() => {
//     minusCountdown();
//   }, 1000);
//   console.log(interval.value);
// });

const minusCountdown = () => {
  console.log("time -1");
  countDown.value = countDown.value - 1;
  if (countDown.value === 0) {
    clearInterval(interval.value);
    emit("timeout");
  }
};
// watch(
//   () => countDown.value,
//   (nval, oval) => {
//     if (nval === 0) {
//       clearInterval(interval.value);
//       emit("timeout");
//     }
//   }
// );
</script>
<style lang="scss"></style>
